<template>
  <nav v-if="MenuUserInstance" class="flex flex-col">
    <TLink
      v-for="item in MenuUserInstance"
      :key="item.name"
      tag="a"
      variant="secondary"
      :href="item.href"
      target="_self"
      class="py-2 px-4 h-6 box-content flex items-center"
      :aria-label="t(item.name)"
    >
      {{ t(item.name) }}
    </TLink>
  </nav>
</template>

<script setup lang="ts">
import { useMenuUser } from '../composables/useMenuUser'

const { MenuUserInstance } = useMenuUser()
</script>
